var indexOf = [].indexOf;

import _ from 'underscore';

import {
  stringifyParams
} from 'helpers/query_params';

angular.module('gym.calendar').factory('EventService', ["$rootScope", "$modal", "$stateParams", "$state", "$window", "$http", "$filter", "$q", "MessageService", "LateCancellationService", "EventTypes", "isInteger", "flash", "ReactModal", function($rootScope, $modal, $stateParams, $state, $window, $http, $filter, $q, MessageService, LateCancellationService, EventTypes, isInteger, flash, ReactModal) {
  return {
    isEditAvailable: function(event) {
      return !isInteger(event.restrict_daily_session_updates_for_wday);
    },
    showEditNotAvailableAlert: function(event) {
      return $modal.open({
        template: require('templates/gyms/calendar/events/daily_session_edit_restriction_details.html.slim'),
        controller: 'DailySessionEditRestrictionDetailsCtrl',
        resolve: {
          event: function() {
            return event;
          }
        }
      });
    },
    status: function(event) {
      var end, now, nowString, start;
      nowString = moment.tz(moment(), $rootScope.gym.tz).format('YYYY-MM-DD HH:mm');
      now = moment(nowString);
      start = event.start_at.getMonth ? moment(event.start_at) : moment(event.start_at, 'YYYY/MM/DD HH:mma');
      end = moment(event.end_at, 'YYYY/MM/DD HH:mma');
      switch (false) {
        case !now.isBefore(start):
          return 'not_started';
        case !(now.isAfter(start) && now.isBefore(end)):
          return 'in_progress';
        case !now.isAfter(start):
          return 'finished';
      }
    },
    eventInstructorNames: function(event) {
      return event.instructor_names.join(', ');
    },
    eventStyleNames: function(event, styles) {
      if (event.style_ids) {
        return styles.filter(function(style) {
          var ref;
          return ref = style.id, indexOf.call(event.style_ids, ref) >= 0;
        }).map(function(item) {
          return item.name;
        }).join(', ');
      } else {
        return event.style_name;
      }
    },
    eventTypeNames: function(event, types) {
      if (event.event_type_ids) {
        return types.filter(function(type) {
          var ref;
          return ref = type.id, indexOf.call(event.event_type_ids, ref) >= 0;
        }).map(function(item) {
          return item.name;
        }).join(', ');
      } else {
        return event.event_type_name;
      }
    },
    eventTypesWithDeleted: function(ids) {
      var deferred;
      deferred = $q.defer();
      EventTypes.getList({
        count: 500,
        include_inactive: 1
      }).then(function(types) {
        var availableTypes;
        availableTypes = types.filter(function(type) {
          var ref;
          return type.active || (Array.isArray(ids) && (ref = type.id, indexOf.call(ids, ref) >= 0)) || type.id === ids;
        });
        return deferred.resolve(availableTypes);
      });
      return deferred.promise;
    },
    goToEdit: function(event) {
      if (this.isEditAvailable(event)) {
        return $state.go('gym.editEvent', {
          eventId: event.id
        });
      } else {
        return this.showEditNotAvailableAlert(event);
      }
    },
    displayRequireActiveMembershipDescription: function() {
      return $modal.open({
        template: require('templates/gyms/calendar/events/require_active_membership_description.html.slim'),
        controller: ["$scope", "$modalInstance", "$rootScope", function($scope, $modalInstance, $rootScope) {
          $scope.excludeInactiveMembers = $rootScope.gym.gym_booking_detail.exclude_inactive_members_from_free_classes;
          $scope.prospectBookingLimit = $rootScope.gym.gym_booking_detail.prospect_booking_limit;
          return $scope.cancel = function() {
            return $modalInstance.dismiss('cancel');
          };
        }]
      });
    },
    displayProximityCheckinDescription: function() {
      return $modal.open({
        template: require('templates/gyms/calendar/events/proximity_checkin_description.html.slim'),
        controller: ["$scope", "$modalInstance", "$rootScope", function($scope, $modalInstance, $rootScope) {
          $scope.excludeInactiveMembers = $rootScope.gym.gym_booking_detail.exclude_inactive_members_from_free_classes;
          $scope.prospectBookingLimit = $rootScope.gym.gym_booking_detail.prospect_booking_limit;
          return $scope.cancel = function() {
            return $modalInstance.dismiss('cancel');
          };
        }]
      });
    },
    addEvent: function(params) {
      return $modal.open({
        template: require('templates/gyms/calendar/events/new_event.html.slim'),
        windowClass: 'drawer__wrapper',
        backdropClass: 'modal-backdrop--drawer',
        resolve: {
          eventDefaults: ["$http", "$rootScope", function($http, $rootScope) {
            var url;
            url = `/gyms/${$rootScope.gym.id}/calendar/event_defaults`;
            return $http.get(url, {
              params: {
                count: 1000
              }
            }).then(function(response) {
              return response.data.collection;
            });
          }]
        },
        controller: ["$scope", "$rootScope", "$modalInstance", "EventTypes", "GradingStyles", "eventDefaults", function($scope, $rootScope, $modalInstance, EventTypes, GradingStyles, eventDefaults) {
          $scope.gym = $rootScope.gym;
          $scope.classrooms = $rootScope.gym.locations;
          $scope.styles = GradingStyles.getList({
            count: 1000,
            slim: 1
          }).$object;
          $scope.time = params != null ? params.time : void 0;
          $scope.eventDefaultId = params != null ? params.eventDefaultId : void 0;
          $scope.close = function() {
            return $modalInstance.close();
          };
          $scope.eventTypes = EventTypes.getList({
            count: 1000
          }).$object;
          return $scope.eventDefaults = eventDefaults;
        }]
      });
    },
    addAppointment: function(params) {
      return $modal.open({
        template: require('templates/gyms/calendar/appointments/new.html.slim'),
        windowClass: 'drawer__wrapper',
        backdropClass: 'modal-backdrop--drawer',
        controller: 'NewAppointmentCtrl',
        resolve: {
          params: function() {
            return params || {};
          }
        }
      });
    },
    nameTooltipText: function() {
      return "Make the event name really descriptive, so you can easily identify what the event is for once it's saved in your calendar.";
    },
    nameTooltip: function() {
      return `<div class="long-content-tooltip-inner">
  ${this.nameTooltipText()}
</div>`;
    },
    maxAttendeesTooltipText: function() {
      return "Attendee limits help you manage class numbers if you have restricted space. If you don't need a limit, just set this to a number like 100. Creating a one-on-one appointment? Set attendees to 1.";
    },
    maxAttendeesTooltip: function() {
      return `<div class="long-content-tooltip-inner">
  ${this.maxAttendeesTooltipText()}
</div>`;
    },
    maxPropspectsTooltipText: function() {
      return "Use this limit to decide how many Prospects you'll allow to attend this event. If there are spaces available for Prospects, new leads will be able to join this event from your website calendar.";
    },
    maxPropspectsTooltip: function() {
      return `<div class="long-content-tooltip-inner">
  ${this.maxPropspectsTooltipText()}
</div>`;
    },
    trainerTooltipText: function() {
      return "You can assign a trainer/instructor to the event. Don't see your trainer in the list? Add them by inviting them as a user to your Clubworx account. Visit the Manage Users page and invite!";
    },
    trainerTooltip: function() {
      return `<div class="long-content-tooltip-inner">
  ${this.trainerTooltipText()}
</div>`;
    },
    eventAppearanceTooltipText: function() {
      return "Choose the places where this event should appear. If the event is for internal use only, remove all selections - the event will only be viewable by signed-in Clubworx users.";
    },
    eventAppearanceTooltip: function() {
      return `<div class="long-content-tooltip-inner">
  ${this.eventAppearanceTooltipText()}
</div>`;
    },
    publicEventTooltipText: function() {
      var gym, name;
      gym = $rootScope.gym;
      name = gym.mobile_app_feature_enabled ? 'mobile app / member portal' : 'member portal';
      return `Public events will appear on your free Clubworx website, as well as the ${name}, if enabled.`;
    },
    publicEventTooltip: function() {
      return `<div class="long-content-tooltip-inner">
  ${this.publicEventTooltipText()}
</div>`;
    },
    websiteHiddenLabel: function() {
      var gym;
      gym = $rootScope.gym;
      switch (false) {
        case !gym.mobile_app_feature_enabled:
          return 'Clubworx website calendar and Mobile app';
        case !gym.member_portal_enabled:
          return 'Clubworx website calendar and Member portal';
        default:
          return 'Clubworx website calendar';
      }
    },
    getEventAppearanceOptions: function() {
      var gym;
      gym = $rootScope.gym;
      return _.compact([
        {
          id: 'website_hidden',
          name: this.websiteHiddenLabel()
        },
        {
          id: 'show_in_kiosk_mode',
          name: 'Class kiosk mode'
        },
        gym.book_and_pay_enabled && {
          id: 'show_in_book_and_pay',
          name: 'Book & Pay'
        },
        {
          id: 'show_in_roll_call',
          name: 'Roll call'
        }
      ]);
    },
    getEventAppearance: function(event) {
      return _.compact([event.show_in_kiosk_mode && 'show_in_kiosk_mode', event.show_in_book_and_pay && 'show_in_book_and_pay', event.show_in_roll_call && 'show_in_roll_call', !event.website_hidden && 'website_hidden']);
    },
    showAttendees: function(event, params) {
      return $modal.open({
        template: require('templates/gyms/calendar/attendeesModal.html.slim'),
        windowClass: 'drawer__wrapper',
        backdropClass: 'modal-backdrop--drawer',
        resolve: {
          event: function() {
            return angular.copy(event);
          },
          params: function() {
            return params;
          },
          refetchDashlets: function() {
            return {};
          }
        },
        controller: 'EventAttendeesModalCtrl'
      });
    },
    confirmLateAbsent: function(params) {
      var modalInstance;
      modalInstance = ReactModal.open({
        component: 'ConfirmLateAbsentModal',
        props: {
          event: params.event,
          booking: params.booking
        }
      });
      return modalInstance.then(function() {
        return params.reloadAttendance();
      }, function() {
        params.booking.attendance = params.previousValue;
        return params.reloadAttendance();
      });
    },
    markAttended: function(booking, previousValue, reload) {
      var url;
      url = `/gyms/${$rootScope.gym.id}/calendar/events/${booking.event_id}/bookings/${booking.id}/mark_attended`;
      return $http.put(url).then(function() {
        return reload();
      }, function(response) {
        reload();
        booking.attendance = previousValue;
        return MessageService.message({
          title: 'Attendance blocked (signed waiver required)',
          message: response.data.error_message
        });
      });
    },
    resetAttendance: function(booking, reload) {
      var url;
      url = `gyms/${$rootScope.gym.id}/calendar/events/${booking.event_id}/bookings/${booking.id}/reset_attendance`;
      return $http.put(url).then(function() {
        return reload();
      });
    },
    updateAttendance: function(booking, previousValue, reload) {
      var params, url;
      if (booking.attendance === 'Attended') {
        return this.markAttended(booking, previousValue, reload);
      } else {
        url = `gyms/${$rootScope.gym.id}/calendar/events/${booking.event_id}/bookings/${booking.id}`;
        params = {
          booking: {
            attendance: booking.attendance
          }
        };
        return $http.put(url, params).then(function() {
          return reload();
        });
      }
    },
    confirmUpdateAttendance: function(params) {
      var booking, event, gym, limitLabel, message;
      gym = $rootScope.gym;
      event = params.event;
      booking = params.booking;
      switch (false) {
        case !(params.previousValue === 'Absent' && params.booking.attendance === 'Attended' && params.event.non_absent_bookings_count >= params.event.participant_limit):
          limitLabel = params.event.participant_limit === 1 ? "1 person" : `${params.event.participant_limit} people`;
          message = [`This event has reached its limit of ${limitLabel}. By marking ${params.studentName}'s booking as Attended, you will be taking the event above capacity.`, "If you do not want this event to be over-booked, please consider changing the capacity limit or removing an existing booking.", 'Choose "Continue" below if you would like to mark this booking as Attended and take the event over capacity.'];
          return MessageService.message({
            title: 'Confirm attendance change',
            message: message,
            confirmButtonText: 'Continue: Change Attendance',
            cancelButtonText: 'Cancel'
          }).then(function() {
            var url;
            this.updateAttendance(params.booking, params.previousValue, params.reloadAttendance);
            url = `/gyms/${gym.id}/calendar/events/${params.event.id}/bookings/${params.booking.id}/confirm_overbooked_event`;
            return $http.put(url);
          }, function() {
            return params.booking.attendance = 'Absent';
          });
        case !(booking.attendance === 'Absent' && event.restrict_cancellations && !booking.cancellable && booking.allow_late_cancellations):
          return this.confirmLateAbsent(params);
        default:
          return this.updateAttendance(params.booking, params.previousValue, params.reloadAttendance);
      }
    },
    openBulkBookingsModal: function(contact, event, bookings) {
      var bulkBookingsModal;
      bulkBookingsModal = $modal.open({
        template: require('templates/gyms/calendar/bulkBookingModal.html.slim'),
        controller: 'BulkBookingsCtrl',
        size: 'lg',
        resolve: {
          event: function() {
            return event;
          },
          contact: function() {
            return contact;
          },
          bookings: function() {
            return bookings;
          }
        }
      });
      return bulkBookingsModal.result;
    },
    getBookings: function(eventId) {
      var deferred, gym, url;
      deferred = $q.defer();
      gym = $rootScope.gym;
      url = `/gyms/${gym.id}/calendar/events/${eventId}/bookings`;
      $http.get(url, {
        params: {
          count: 1000
        }
      }).then(function(response) {
        return deferred.resolve(response.data.collection);
      }, function(response) {
        return deferred.reject(response.data);
      });
      return deferred.promise;
    },
    getCancelledBookings: function(eventId, eventCancellationId = null) {
      var deferred, filters, gym, params, url;
      deferred = $q.defer();
      gym = $rootScope.gym;
      url = `/gyms/${gym.id}/calendar/cancelled_bookings`;
      filters = {
        event_id: eventId,
        removed_by: 'archived_by_event_cancellation'
      };
      if (eventCancellationId) {
        filters.event_cancellation_id = eventCancellationId;
      }
      params = stringifyParams({
        count: 1000,
        filters: filters
      });
      $http.get(url, {
        params: params
      }).then(function(response) {
        return deferred.resolve(response.data.collection);
      }, function(response) {
        return deferred.reject(response.data);
      });
      return deferred.promise;
    },
    getRecurringBookings: function(filters) {
      var deferred, gym, params, url;
      deferred = $q.defer();
      gym = $rootScope.gym;
      if (gym.gym_config.recurring_bookings_feature_enabled) {
        url = `/gyms/${gym.id}/calendar/recurring_bookings`;
        params = stringifyParams({
          count: 1000,
          filters: filters
        });
        $http.get(url, {
          params: params
        }).then(function(response) {
          return deferred.resolve(response.data.collection);
        }, function(response) {
          return deferred.reject(response.data);
        });
      } else {
        deferred.resolve([]);
      }
      return deferred.promise;
    },
    getContactForBooking: function(contactName, contactId, eventId) {
      var deferred, gym, url;
      deferred = $q.defer();
      gym = $rootScope.gym;
      url = `/gyms/${gym.id}/contacts/for_booking?event_id=${eventId}&search=${contactName}`;
      $http.get(url).then(function(response) {
        var contact;
        contact = _.find(response.data.collection, function(item) {
          return item.id === contactId;
        });
        if (contact) {
          return deferred.resolve(contact);
        }
      });
      return deferred.promise;
    },
    selectBookingType: function(contact, event) {
      var deferred, modal;
      deferred = $q.defer();
      if (contact.type === 'member' && !event.free_class) {
        modal = $modal.open({
          template: require('templates/gyms/calendar/selectBookingTypeModal.html.slim'),
          controller: 'SelectBookingTypeCtrl',
          resolve: {
            event: function() {
              return event;
            },
            contact: function() {
              return contact;
            }
          }
        });
        modal.result.then(function(data) {
          return deferred.resolve(data);
        });
      } else {
        deferred.resolve({
          free_class: false
        });
      }
      return deferred.promise;
    },
    addSingleBooking: function(contact, event, bookings, deferred) {
      return this.selectBookingType(contact, event).then(function(data) {
        var params, url;
        params = {
          position: bookings.length + 1,
          student: contact,
          free_class: data.free_class,
          add_makeup_class: data.add_makeup_class,
          makeup_class_membership_id: data.makeup_class_membership_id,
          makeup_class_reason: data.makeup_class_reason
        };
        url = `/gyms/${$rootScope.gym.id}/calendar/events/${event.id}/bookings`;
        return $http.post(url, {
          booking: params
        }).then(function(response) {
          flash.success = `Booking for ${response.data.student.name} added successfully`;
          return deferred.resolve();
        }, function(response) {
          var errorDetails, studentName;
          data = response.data;
          studentName = data.student.name || `${data.student.first_name} ${data.student.last_name}`;
          errorDetails = (function() {
            switch (false) {
              case !data.errors.event:
                return `: ${data.errors.event.join(', ')}`;
              case !data.errors.student:
                return `: ${data.errors.student.join(', ')}`;
              default:
                return '';
            }
          })();
          return flash.error = `Booking for ${studentName} failed${errorDetails}`;
        });
      });
    },
    addBooking: function(contact, event, bookings) {
      var deferred, gym, message, prospectBookingLimit;
      deferred = $q.defer();
      gym = $rootScope.gym;
      if (event.all_events_count > 1) {
        this.openBulkBookingsModal(contact, event, bookings).then(function() {
          return deferred.resolve();
        });
      } else {
        prospectBookingLimit = gym.gym_booking_detail.prospect_booking_limit;
        if (contact.type === 'prospect' && prospectBookingLimit !== null && contact.non_absent_booking_count >= prospectBookingLimit) {
          message = `This prospect has already made ${contact.non_absent_booking_count} booking(s). Click Save below to proceed and create the booking anyway.`;
          MessageService.message({
            title: 'Add booking',
            message: message,
            confirmButtonText: 'Save'
          }).then(() => {
            return this.addSingleBooking(contact, event, bookings, deferred);
          });
        } else {
          this.addSingleBooking(contact, event, bookings, deferred);
        }
      }
      return deferred.promise;
    },
    removeBooking: function(booking, event) {
      var deferred, modalInstance;
      deferred = $q.defer();
      if (event.restrict_cancellations && !booking.cancellable && booking.allow_late_cancellations) {
        LateCancellationService.cancel(booking).result.then(function() {
          flash.success = "Booking successfully cancelled";
          return deferred.resolve();
        });
      } else {
        modalInstance = $modal.open({
          template: require('templates/gyms/calendar/cancel_bookings_modal.html.slim'),
          resolve: {
            booking: function() {
              return booking;
            },
            contact: function() {
              return booking.student;
            },
            fromContactProfile: function() {
              return false;
            }
          },
          controller: 'CancelBookingsCtrl'
        });
        modalInstance.result.then(function() {
          return deferred.resolve();
        });
      }
      return deferred.promise;
    },
    enableRecurringBooking: function(booking, recurringBookingParams, eventId) {
      var deferred, gym, url;
      deferred = $q.defer();
      gym = $rootScope.gym;
      url = `/gyms/${gym.id}/calendar/events/${eventId}/recurring_bookings`;
      recurringBookingParams.booking_method = booking.free_class ? 'free_bookings_method' : 'use_membership_method';
      $http.post(url, {
        recurring_booking_detail: recurringBookingParams
      }).then(function(response) {
        $modal.open({
          template: require('templates/gyms/calendar/recurring_bookings_enabled_modal.html.slim'),
          controller: 'RecurringBookingsEnabledModalCtrl',
          resolve: {
            params: function() {
              return response.data;
            }
          }
        });
        return deferred.resolve();
      }, function(response) {
        return deferred.reject(response.data);
      });
      return deferred.promise;
    },
    addToWaitlist: function(contact, event) {
      var deferred, gym, url;
      deferred = $q.defer();
      gym = $rootScope.gym;
      url = `/gyms/${gym.id}/calendar/events/${event.id}/waitlist_attendees`;
      $http.post(url, {
        contact_id: contact.id
      }).then(function(response) {
        deferred.resolve();
        return flash.success = `${response.data.contact_name} added to waitlist`;
      }, function(response) {
        deferred.reject();
        if (response.data.error_message) {
          return flash.error = response.data.error_message;
        }
      });
      return deferred.promise;
    },
    removeFromWaitlist: function(waitlist) {
      return ReactModal.open({
        component: 'RemoveFromWaitlistModal',
        props: {
          waitlist: waitlist
        }
      });
    },
    changeWaitlistPosition: function(waitlist, change) {
      var deferred, gym, url;
      deferred = $q.defer();
      gym = $rootScope.gym;
      url = `/gyms/${gym.id}/calendar/events/${waitlist.event_id}/waitlist_attendees/${waitlist.id}/change_position`;
      $http.put(url, {
        change: change
      }).then(function() {
        return deferred.resolve();
      }, function(response) {
        if (response.data.error_message) {
          flash.error = response.data.error_message;
        }
        return deferred.reject();
      });
      return deferred.promise;
    },
    waitlistPlacesAvailable: function(event) {
      var attendeeCount, limit;
      if (!event.waitlist_attendee_count && !event.waitlist_limit) {
        return '';
      }
      attendeeCount = event.waitlist_attendee_count;
      limit = isInteger(event.waitlist_limit) ? event.waitlist_limit : 'no limit';
      return `${attendeeCount}/${limit}`;
    },
    bookNow: function(waitlist, event) {
      var deferred, eventTime;
      deferred = $q.defer();
      eventTime = $filter('stringToDate')(event.start_at, 'YYYY/MM/DD HH:mm', 'MMM D, YYYY h:mma');
      MessageService.message({
        title: 'About Recurring Bookings',
        message: [`${_.escape(waitlist.event_name)}, ${eventTime}`, `${_.escape(waitlist.contact_name)}`, `<strong>This event has reached its limit of ${event.participant_limit} people.</strong> To create a booking for this contact, it will be necessary to increase the event's attendance limit to ${event.participant_limit + 1}.`, 'Choose "Create Booking" below to make this change now.'],
        bindHtml: true,
        confirmButtonText: 'Create Booking',
        displayCancelButton: true
      }).then(function() {
        var gym, url;
        gym = $rootScope.gym;
        url = `/gyms/${gym.id}/calendar/events/${waitlist.event_id}/waitlist_attendees/${waitlist.id}/promote`;
        return $http.put(url).then(function() {
          flash.success = 'Booking added successfully';
          return deferred.resolve();
        }, function(response) {
          if (response.data.error_message) {
            flash.error = response.data.error_message;
          }
          return deferred.reject();
        });
      });
      return deferred.promise;
    },
    displayRecurringBookingsDescription: function() {
      return MessageService.message({
        title: 'About Recurring Bookings',
        message: ["<strong>Recurring bookings make it easy to enrol a contact in bookings for an event series that runs forever.</strong>", 'When you set up an event series to repeat "until further notice", Clubworx will generate 365 days worth of events for that series immediately, and then new events will be added to the end of the series as necessary, on a weekly basis.', 'However: when a contact books into an infinite event series using "Book All", they are <strong>only booked into the events that currently exist</strong>.', "<strong>Recurring bookings</strong> can be used to book a contact into all events that currently exist in a series, as well as any new events that may be added to the series in future.", "Once enabled, recurring bookings can be turned off at any time, from the event calendar or the contact profile page."],
        bindHtml: true
      });
    }
  };
}]);
